export default "__VITE_ASSET__df17f1fd__"